module.exports = __webpack_public_path__ + "media/images/gray-570a615662555f5258d95a60c66672b7.png";